// extracted by mini-css-extract-plugin
export default {"itemBody":"downloadable_itemBody__sFSh+","dropdown":"downloadable_dropdown__ZnRtY"};